import { Box, IconButton, ScaleFade, useMediaQuery } from '@chakra-ui/react'
import { FC, useEffect, useRef, useState } from 'react'
import { AiOutlinePushpin } from 'react-icons/ai'
import { BsClockHistory } from 'react-icons/bs'
import { FaAngleRight, FaAngleLeft } from 'react-icons/fa'
import { RiShoppingCartLine } from 'react-icons/ri'
import { useHistory } from 'react-router'
import Slider, { Settings } from 'react-slick'

import useHome from '@hook/shared/use-home'

import InfoCard from '@component/Layout/Card/Info'

import './Carousel-styles.css'

export type SliderSettings = Settings

interface IOverviewCardsProps {
  empresas: Array<number>
}

const OverviewCards: FC<IOverviewCardsProps> = ({ empresas }) => {
  const history = useHistory()
  const sliderRef = useRef<Slider>(null)

  const {
    dataFollowUp,
    getDataFollowUp,
    dataFollowUpReab,
    getDataFollowUpReab,
    loadingFollowUp,
    loadingFollowUpReab,
    dataAlerta,
    loadingAlerta,
    getDataAlerta
  } = useHome()

  const [position, setPosition] = useState(0)

  const [isLargerThanHD, isDisplayingInBrowser] = useMediaQuery([
    '(min-width: 1024px)',
    '(display-mode: browser)'
  ])

  useEffect(() => {
    if (dataFollowUp === null) {
      getDataFollowUp(empresas)
    }
    if (dataFollowUpReab === null) {
      getDataFollowUpReab(empresas)
    }
    if (
      dataAlerta.alertaCompras === null &&
      dataAlerta.alertaRecebimento === null
    ) {
      getDataAlerta(empresas)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresas])

  const settings: SliderSettings = {
    speed: 300,
    variableWidth: true,
    arrows: false,
    infinite: false,
    afterChange: setPosition
  }

  const handleNext = () => sliderRef.current?.slickNext()

  const handlePrev = () => sliderRef.current?.slickPrev()

  return (
    <section className="cards-slider">
      <Slider ref={sliderRef} {...settings}>
        <Box marginRight={4}>
          <InfoCard
            title="Follow up Compras"
            value={
              dataFollowUp &&
              dataFollowUp.toLocaleString('pt-br', {
                maximumFractionDigits: 0
              })
            }
            icon={<AiOutlinePushpin />}
            isLoading={loadingFollowUp}
            action={() => {
              history.push('/alertas/follow-up')
            }}
          />
        </Box>
        <Box marginRight={4}>
          <InfoCard
            title="Follow up Reabastecimento"
            value={
              dataFollowUpReab &&
              dataFollowUpReab.toLocaleString('pt-br', {
                maximumFractionDigits: 0
              })
            }
            icon={<AiOutlinePushpin />}
            isLoading={loadingFollowUpReab}
            action={() => {
              history.push('/alertas/follow-up-reab')
            }}
          />
        </Box>

        <Box marginRight={4}>
          <InfoCard
            title="Alertas de compras"
            value={
              dataAlerta.alertaCompras &&
              dataAlerta.alertaCompras.toLocaleString('pt-br', {
                maximumFractionDigits: 0
              })
            }
            icon={<RiShoppingCartLine />}
            isLoading={loadingAlerta}
            action={() => {
              history.push('/alertas/compra')
            }}
          />
        </Box>
        <InfoCard
          title="Alertas de adiantamentos"
          icon={<BsClockHistory />}
          value={
            dataAlerta.alertaRecebimento &&
            dataAlerta.alertaRecebimento.toLocaleString('pt-br', {
              maximumFractionDigits: 0
            })
          }
          isLoading={loadingAlerta}
          action={() => {
            history.push('/alertas/compra')
          }}
        />
      </Slider>

      <Box pos="absolute" top="50%" left={'-16px'} transform="translateY(-50%)">
        <ScaleFade initialScale={0.9} in={position > 0} unmountOnExit>
          <IconButton
            size="sm"
            variant="unstyled"
            colorScheme="yellow"
            aria-label="Anterior"
            icon={<FaAngleLeft />}
            fontSize={24}
            display="flex"
            onClick={handlePrev}
            transition="all ease .3s"
            _hover={{
              fontSize: 20,
              display: 'flex',
              justifyContent: 'center',
              background: '#fad954'
            }}
          />
        </ScaleFade>
      </Box>
      {!isLargerThanHD && isDisplayingInBrowser && position !== 2 && (
        <Box
          pos="absolute"
          top="50%"
          right={'-16px'}
          transform="translateY(-50%)"
        >
          <ScaleFade initialScale={0.9} in={position < 6} unmountOnExit>
            <IconButton
              size="sm"
              variant="unstyled"
              colorScheme="yellow"
              aria-label="Posterior"
              icon={<FaAngleRight />}
              fontSize={24}
              display="flex"
              onClick={handleNext}
              transition="all ease .3s"
              _hover={{
                fontSize: 20,
                display: 'flex',
                justifyContent: 'center',
                background: '#fad954'
              }}
            />
          </ScaleFade>
        </Box>
      )}
    </section>
  )
}

export default OverviewCards
